import { QueryClient, QueryClientProvider, InvalidateQueryFilters, MutationCache } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { PropsWithChildren } from "react";

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess(_data, _variables, _context, mutation) {
      if (mutation.meta?.invalidateQueries) {
        queryClient.invalidateQueries(
          mutation.meta.invalidateQueries as InvalidateQueryFilters<readonly unknown[]>,
        );
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

export const ReactQueryProvider = ({ children }: PropsWithChildren) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
